const sushiswap = require("./sushiswap");

const TOKEN_SYMBOL_TO_ADDRESS = {
  SUSHI: "0x2995d1317dcd4f0ab89f4ae60f3f020a4f17c7ce",
  GNO: "0x9c58bacc331c9aa871afd802db6379a98e80cedb",
  USDC: "0xddafbb505ad214d7b80b1f830fccc89b60fb7a83",
  USDT: "0x4ecaba5870353805a9f068101a40e0f32ed605c6",
  WXDAI: "0xe91d153e0b41518a2ce8dd3d7944fa863463a97d",
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.GNO]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.USDC]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.USDT]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.WXDAI]: 18,
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WXDAI;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WXDAI;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  PROTOCOLS: {
    sushiswap
  },
  NATIVE_TOKEN,
};
